export { default } from './closed-captions/closed-captions.angular';
